import { SVGProps } from 'react';

interface IconProps extends SVGProps<SVGSVGElement> {
  weight?: 'fill' | 'regular';
}

export const SentimentSatisfied = ({
  width = 24,
  height = 24,
  weight = 'regular',
}: IconProps) => {
  if (weight === 'fill') {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 25 24"
        fill="none"
      >
        <mask
          id="mask0_2753_199958"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width={width}
          height={height}
        >
          <rect
            x="0.399902"
            width={width}
            height={height}
            fill="currentColor"
          />
        </mask>
        <g mask="url(#mask0_2753_199958)">
          <path
            d="M15.8059 10.8077C16.1699 10.8077 16.4785 10.6803 16.7317 10.4255C16.9848 10.1708 17.1114 9.86158 17.1114 9.49775C17.1114 9.13392 16.9841 8.82542 16.7294 8.57225C16.4747 8.31892 16.1654 8.19225 15.8014 8.19225C15.4376 8.19225 15.1291 8.31967 14.8759 8.5745C14.6227 8.82917 14.4962 9.13842 14.4962 9.50225C14.4962 9.86608 14.6235 10.1746 14.8782 10.4277C15.1328 10.6811 15.4421 10.8077 15.8059 10.8077ZM8.9984 10.8077C9.36224 10.8077 9.67074 10.6803 9.9239 10.4255C10.1771 10.1708 10.3037 9.86158 10.3037 9.49775C10.3037 9.13392 10.1763 8.82542 9.92165 8.57225C9.66699 8.31892 9.35774 8.19225 8.9939 8.19225C8.6299 8.19225 8.32132 8.31967 8.06815 8.5745C7.81499 8.82917 7.6884 9.13842 7.6884 9.50225C7.6884 9.86608 7.81574 10.1746 8.0704 10.4277C8.32507 10.6811 8.6344 10.8077 8.9984 10.8077ZM12.3999 17.1923C13.4434 17.1923 14.3972 16.9003 15.2614 16.3163C16.1256 15.7323 16.7627 14.9602 17.1729 14H15.8499C15.4832 14.6167 14.9957 15.1042 14.3874 15.4625C13.7791 15.8208 13.1166 16 12.3999 16C11.6832 16 11.0207 15.8208 10.4124 15.4625C9.80407 15.1042 9.31657 14.6167 8.9499 14H7.6269C8.03707 14.9602 8.67424 15.7323 9.5384 16.3163C10.4026 16.9003 11.3564 17.1923 12.3999 17.1923ZM12.4017 21.5C11.0877 21.5 9.85257 21.2507 8.6964 20.752C7.54024 20.2533 6.53457 19.5766 5.6794 18.7218C4.82424 17.8669 4.14715 16.8617 3.64815 15.706C3.14932 14.5503 2.8999 13.3156 2.8999 12.0017C2.8999 10.6877 3.14924 9.45267 3.6479 8.2965C4.14657 7.14033 4.82332 6.13467 5.67815 5.2795C6.53299 4.42433 7.53824 3.74725 8.6939 3.24825C9.84957 2.74942 11.0843 2.5 12.3982 2.5C13.7122 2.5 14.9472 2.74933 16.1034 3.248C17.2596 3.74667 18.2652 4.42342 19.1204 5.27825C19.9756 6.13308 20.6527 7.13833 21.1517 8.294C21.6505 9.44967 21.8999 10.6844 21.8999 11.9983C21.8999 13.3123 21.6506 14.5473 21.1519 15.7035C20.6532 16.8597 19.9765 17.8653 19.1217 18.7205C18.2668 19.5757 17.2616 20.2528 16.1059 20.7518C14.9502 21.2506 13.7155 21.5 12.4017 21.5Z"
            fill="currentColor"
          />
        </g>
      </svg>
    );
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      <mask
        id="mask0_2753_67061"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={width}
        height={height}
      >
        <rect width={width} height={height} fill="currentColor" />
      </mask>
      <g mask="url(#mask0_2753_67061)">
        <path
          d="M15.406 10.8077C15.77 10.8077 16.0786 10.6803 16.3318 10.4255C16.5849 10.1708 16.7115 9.86158 16.7115 9.49775C16.7115 9.13392 16.5842 8.82542 16.3295 8.57225C16.0748 8.31892 15.7655 8.19225 15.4015 8.19225C15.0377 8.19225 14.7292 8.31967 14.476 8.5745C14.2228 8.82917 14.0962 9.13842 14.0962 9.50225C14.0962 9.86608 14.2236 10.1746 14.4783 10.4277C14.7329 10.6811 15.0422 10.8077 15.406 10.8077ZM8.5985 10.8077C8.96233 10.8077 9.27083 10.6803 9.524 10.4255C9.77717 10.1708 9.90375 9.86158 9.90375 9.49775C9.90375 9.13392 9.77642 8.82542 9.52175 8.57225C9.26708 8.31892 8.95783 8.19225 8.594 8.19225C8.23 8.19225 7.92142 8.31967 7.66825 8.5745C7.41508 8.82917 7.2885 9.13842 7.2885 9.50225C7.2885 9.86608 7.41583 10.1746 7.6705 10.4277C7.92517 10.6811 8.2345 10.8077 8.5985 10.8077ZM12 17.1923C13.0435 17.1923 13.9973 16.9003 14.8615 16.3163C15.7257 15.7323 16.3628 14.9602 16.773 14H15.45C15.0833 14.6167 14.5958 15.1042 13.9875 15.4625C13.3792 15.8208 12.7167 16 12 16C11.2833 16 10.6208 15.8208 10.0125 15.4625C9.40417 15.1042 8.91667 14.6167 8.55 14H7.227C7.63717 14.9602 8.27433 15.7323 9.1385 16.3163C10.0027 16.9003 10.9565 17.1923 12 17.1923ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5ZM12 20C14.2333 20 16.125 19.225 17.675 17.675C19.225 16.125 20 14.2333 20 12C20 9.76667 19.225 7.875 17.675 6.325C16.125 4.775 14.2333 4 12 4C9.76667 4 7.875 4.775 6.325 6.325C4.775 7.875 4 9.76667 4 12C4 14.2333 4.775 16.125 6.325 17.675C7.875 19.225 9.76667 20 12 20Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
